import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Baseproperties } from "src/app/views/utility/baseproperties";
import { Router } from "@angular/router";
import { Departments } from "../../utility/modals";

@Injectable({
    providedIn: 'root'
  })
  export class DepartmentService
  {
    baseproperties: Baseproperties = new Baseproperties(); 
    private baseURL = this.baseproperties.gatewayBaseURL+"/common"
    scrollHeight: string = '22em'; 
    constructor(private httpClient: HttpClient,private route:Router) { }
    //DepartmentService
  
  getOptionDropdown(length):Array<any>{
    let options=[]
    let pairSize = 10;
    let numberOfPairs = Math.ceil(length / pairSize);   // Calculate the number of pairs
    let pairsArray = Array.from({ length: numberOfPairs }, (_, index) => {
      const end = Math.min((index + 1) * pairSize, length); // Create the array of pairs
      return [end];
    });
    pairsArray.map((e)=>{
      options.push({'label':e[0],value:e[0]})
    });
    return options
  }
  

  departmentDataExcel()
  {
    
     return this.httpClient.get(`${this.baseURL}/department/departmentDataExcel`,{ responseType: 'blob' }); 
  }
  excelUploadFormat()
  {

     return this.httpClient.get(`${this.baseURL}/department/bulkuploadTempExcel`,{ responseType: 'blob' }); 
  }
  bulkUpload(data: FormData): Observable<any> {
    console.log(data,"mydata");
    
    return this.httpClient.post<Observable<any>>(`${this.baseURL}/department/uploadExcel`, data);
  }
  //Add New Departments
  addDepartment(department): Observable<Object>{
    return this.httpClient.post(`${this.baseURL}/department/createdepartment`, department);
  }
  getDepartmentById(id: number): Observable<Departments>{
    return this.httpClient.get<Departments>(`${this.baseURL}/department/getdepartmentbyid/${id}`);
  }
  updateDepartment(department: Departments): Observable<Object>{
    return this.httpClient.post(`${this.baseURL}/department/modifydepartmentdata`, department);
    }
    getDepartmentData(): Observable<any> {
        return this.httpClient.get(`${this.baseURL}/department/getall`);
      }
      getdepartmentforlist(): Observable<any>{
        return this.httpClient.get<Observable<any>>(`${this.baseURL}/department/departmentdata`);
      }

      getConfiguration(): Observable<any[]> {
      return this.httpClient.get<any[]>(`${this.baseURL}/department/getconfiguration`);
    }

    inactivateDepartment(payload: any): Observable<Object> {
        return this.httpClient.post(`${this.baseURL}/department/inactivatedepartment`, payload);
      }
  }